// THE NICK FRASER ARCHIVE — prospectus content.
// Single source of truth for /archive-prospectus. Edit copy, captions,
// credits, timeline entries and links here; the page renders from this file.
// The A4 PDF (backend/prospectus_pdf.py) mirrors this content.

export const PROSPECTUS_META = {
  title: "The Nick Fraser Archive",
  subtitle: "The life, work and legacy of an overlooked East London artist",
  publisher: "The Estate of Nick Fraser",
  edition: "First Edition — June 2026",
  version: "Version 1.0",
  contactEmail: "info@nickfraserartist.com",
  website: "nickfraserartist.com",
  chapterSite: "chapter2.nickfraserartist.com",
  instagram: "@nickfraserart · @Marxjamesart",
  platform: "imaginative-reaction.org",
};

// ── Image placeholders ───────────────────────────────────────────────
// Every image is a labelled placeholder. Supply final images against
// these IDs; captions and credits are drafted where context exists and
// marked TBC where they are not.
export const PROSPECTUS_IMAGES = {
  COVER_ARTWORK: {
    label: "COVER_ARTWORK",
    note: "Single full-bleed painting for the cover. A work with strong central presence recommended.",
    caption: "Cover artwork — title, date and medium TBC.",
    credit: "TBC",
    aspect: "portrait",
  },
  NICK_PORTRAIT: {
    label: "NICK_PORTRAIT",
    note: "Archive photograph of Nick Fraser.",
    caption: "Nick Fraser (1946–2023). Date and photographer TBC.",
    credit: "TBC",
    aspect: "portrait",
  },
  TATE_AND_LYLE_ARCHIVE_IMAGE: {
    label: "TATE_AND_LYLE_ARCHIVE_IMAGE",
    note: "Period photograph relating to Tate & Lyle or East London industrial work. Must be rights-cleared.",
    caption: "Caption TBC — East London industrial context.",
    credit: "TBC",
    aspect: "landscape",
  },
  HIDDEN_PRACTICE_ARTWORK_01: {
    label: "HIDDEN_PRACTICE_ARTWORK_01",
    note: "A painting illustrating Nick's use of everyday materials.",
    caption: "Title, date and medium TBC.",
    credit: "The Estate of Nick Fraser — TBC",
    aspect: "portrait",
  },
  THEMES_ARTWORK_01: {
    label: "THEMES_ARTWORK_01",
    note: "A painting representing the sacred / devotional register of the work.",
    caption: "Title, date and medium TBC.",
    credit: "The Estate of Nick Fraser — TBC",
    aspect: "portrait",
  },
  THEMES_ARTWORK_02: {
    label: "THEMES_ARTWORK_02",
    note: "A painting representing the bodily / figurative register of the work.",
    caption: "Title, date and medium TBC.",
    credit: "The Estate of Nick Fraser — TBC",
    aspect: "square",
  },
  FULL_PAGE_ARTWORK_01: {
    label: "FULL_PAGE_ARTWORK_01",
    note: "Full-page artwork moment (print) / full-width image (web).",
    caption: "Title, date and medium TBC.",
    credit: "The Estate of Nick Fraser — TBC",
    aspect: "wide",
  },
  FULL_PAGE_ARTWORK_02: {
    label: "FULL_PAGE_ARTWORK_02",
    note: "Second full-page artwork moment (print) / full-width image (web).",
    caption: "Title, date and medium TBC.",
    credit: "The Estate of Nick Fraser — TBC",
    aspect: "wide",
  },
  COLLECTION_OVERVIEW_IMAGE: {
    label: "COLLECTION_OVERVIEW_IMAGE",
    note: "Photograph of works in storage / the archive as an object (stacked canvases, panels).",
    caption: "Works from the archive awaiting formal cataloguing. Caption TBC.",
    credit: "TBC",
    aspect: "landscape",
  },
  DOCUMENTARY_STILL_01: {
    label: "DOCUMENTARY_STILL_01",
    note: "Still from Mark O'Shaughnessy's documentary footage.",
    caption: "Still from the documentary record. Caption TBC.",
    credit: "Mark O'Shaughnessy — TBC",
    aspect: "landscape",
  },
  DOCUMENTARY_STILL_02: {
    label: "DOCUMENTARY_STILL_02",
    note: "Second documentary still (Nick speaking or at work, if available).",
    caption: "Still from the documentary record. Caption TBC.",
    credit: "Mark O'Shaughnessy — TBC",
    aspect: "landscape",
  },
  RAW_VISION_FEATURE_IMAGE: {
    label: "RAW_VISION_FEATURE_IMAGE",
    note: "Photograph of the Raw Vision Issue 121 feature spread (rights-cleared).",
    caption: "Nick Fraser featured in Raw Vision, Issue 121. Caption TBC.",
    credit: "Raw Vision — permission TBC",
    aspect: "landscape",
  },
  CHAPTER_1_INSTALLATION_01: {
    label: "CHAPTER_1_INSTALLATION_01",
    note: "Installation photograph — Chapter 1, The Crypt Gallery.",
    caption: "Chapter 1, The Crypt Gallery, London, 2024. Photographer TBC.",
    credit: "TBC",
    aspect: "landscape",
  },
  CHAPTER_1_INSTALLATION_02: {
    label: "CHAPTER_1_INSTALLATION_02",
    note: "Second installation photograph — Chapter 1.",
    caption: "Chapter 1, The Crypt Gallery, London, 2024. Photographer TBC.",
    credit: "TBC",
    aspect: "landscape",
  },
  CHAPTER_2_INSTALLATION_01: {
    label: "CHAPTER_2_INSTALLATION_01",
    note: "Installation photograph — Chapter II, Shoreditch Arts Club (to be added after 31 July 2026; a projection/preview image may be used in the interim).",
    caption: "Chapter II, Shoreditch Arts Club, London, 31 July 2026. TBC.",
    credit: "TBC",
    aspect: "landscape",
  },
  PRESERVATION_ARCHIVE_IMAGE: {
    label: "PRESERVATION_ARCHIVE_IMAGE",
    note: "Photograph illustrating condition / storage / conservation need.",
    caption: "Caption TBC — the archive as it is currently held.",
    credit: "TBC",
    aspect: "landscape",
  },
  MARK_AND_MARCUS_PORTRAIT: {
    label: "MARK_AND_MARCUS_PORTRAIT",
    note: "Portrait of Mark and Marcus O'Shaughnessy.",
    caption: "Mark and Marcus O'Shaughnessy, custodians of the archive. Photographer TBC.",
    credit: "TBC",
    aspect: "landscape",
  },
};

export const PROSPECTUS_FILMS = [
  {
    title: "Nick Fraser — the Chapter 1 film",
    url: "https://www.youtube.com/watch?v=bjPlwtp4zzg",
    embed: "https://www.youtube-nocookie.com/embed/bjPlwtp4zzg?rel=0&modestbranding=1",
    note: "The documentary film screened within Chapter 1 at The Crypt Gallery, drawing on Mark O'Shaughnessy's footage and recollections.",
  },
  {
    title: "Chapter II — exhibition trailer",
    url: "https://www.youtube.com/watch?v=aWdQc4BjKG8",
    embed: "https://www.youtube-nocookie.com/embed/aWdQc4BjKG8?rel=0&modestbranding=1",
    note: "The short film announcing Chapter II at Shoreditch Arts Club, 31 July 2026.",
  },
];

export const PROSPECTUS_TIMELINE = [
  { year: "1946", text: "Nick Fraser is born in East London." },
  { year: "1960s", text: "Begins painting privately. The earliest works in the archive are understood to date from this period." },
  { year: "1970s–2000s", text: "Works for more than three decades at the Tate & Lyle factory while continuing to paint privately. (Exact employment dates to be confirmed from records.)" },
  { year: "During his lifetime", text: "The work is shown publicly only on rare occasions, in small pop-up settings including Lewisham Library and the Cutty Sark, Greenwich. (Dates to be confirmed.)" },
  { year: "2023", text: "Nick Fraser dies. The archive passes into the care of his lifelong friend Mark O'Shaughnessy and Mark's son, Marcus." },
  { year: "April 2024", text: "The first public exhibition is announced; Marcus O'Shaughnessy speaks to Vibe 107.6 FM about bringing Nick's work to light." },
  { year: "2024", text: "Chapter 1 opens at The Crypt Gallery, St Pancras Parish Church, London — the first substantial public showing of the work. Reviewed by Strand Magazine." },
  { year: "Raw Vision, Issue 121", text: "Nick Fraser's life and work are the subject of a written feature by Artemis Van Dorssen in the international journal of outsider and visionary art." },
  { year: "31 July 2026", text: "Chapter II — a one-day exhibition at Shoreditch Arts Club, London, with an immersive projection installation, film screening and the first limited edition prints." },
];

export const PROSPECTUS_COLLECTION = [
  {
    title: "Paintings",
    body: "Large-scale paintings and multi-panel works spanning the 1960s to the artist's later life, made with construction materials and decorating supplies alongside conventional paint. Figurative, symbolic and abstract registers recur across the body of work.",
  },
  {
    title: "Works on everyday surfaces",
    body: "Works made on boards, panels and other surfaces drawn from working life — a defining material record of art made outside the studio economy.",
  },
  {
    title: "Documentary film footage",
    body: "Footage recorded by Mark O'Shaughnessy across his long friendship with the artist, elements of which formed the film screened at Chapter 1.",
  },
  {
    title: "Photographs",
    body: "Photographs of the artist, the work and its settings, held by the estate and by those who knew him.",
  },
  {
    title: "Oral histories & contextual records",
    body: "First-hand recollection — principally Mark O'Shaughnessy's — of Nick's life, working methods, faith and character, together with contextual material gathered by the estate.",
  },
  {
    title: "Press & publication record",
    body: "The growing public record: the Strand Magazine review of Chapter 1, the Raw Vision Issue 121 feature, local radio coverage and the estate's own published materials.",
  },
  {
    title: "Exhibition materials",
    body: "Curatorial texts, installation photography, flyers, film and print materials from Chapter 1 and Chapter II.",
  },
];

export const PROSPECTUS_HERITAGE_THEMES = [
  "Post-war working-class Britain, seen from inside a single working life",
  "East London industrial and social history",
  "Tate & Lyle and the culture of factory work",
  "Hidden creativity outside formal cultural institutions",
  "Self-taught artistic practice and improvised materials",
  "The relationship between labour and private creative expression",
  "Faith, masculinity, identity, isolation and mental wellbeing",
  "Overlooked voices within British art history",
  "Documentary footage, oral histories and contextual records held alongside the paintings",
];

// ── Sections ─────────────────────────────────────────────────────────
// Block types: p (paragraph), pull (pull quote), figure (image slot),
// list, timeline, cards, films, contact.
export const PROSPECTUS_SECTIONS = [
  {
    id: "introduction",
    num: "01",
    navLabel: "Curatorial introduction",
    title: "Curatorial introduction",
    lede: "By Marcus O'Shaughnessy — curator, co-custodian of the Nick Fraser legacy and founder of Imaginative Reaction CIC.",
    draft: true,
    blocks: [
      { type: "p", text: "I did not discover Nick Fraser in a gallery, an art fair or an auction catalogue. I grew up around him. He was my father's lifelong friend — a familiar, quietly spoken presence from the East London world I come from — and for most of my life I had no real idea of the scale of what he was making behind closed doors." },
      { type: "p", text: "When Nick died in 2023, my father and I began the work of looking after what he left behind: decades of paintings, most of which had never been photographed, titled or publicly shown. Standing among them for the first time was not like visiting an exhibition. It was like being handed someone's inner life and asked, without words, to take care of it." },
      { type: "p", text: "That is what this publication is: an introduction to that responsibility. Chapter 1, at The Crypt Gallery, showed us that the work speaks powerfully to people who never met him. Chapter II continues that revelation in the East London that made him. But exhibitions are moments — an archive is a lifetime. The purpose of The Nick Fraser Archive is to make sure that this body of work, and the story of the man who made it, are preserved, understood and made available beyond the two of us who currently carry it." },
      { type: "p", text: "We are not claiming a finished place for Nick in art history. We are asking the people best qualified to help — museums, archives, researchers, funders and cultural organisations — to look at the evidence with us. This prospectus sets out that evidence as plainly and honestly as we can." },
      { type: "p", text: "— Marcus O'Shaughnessy, London, 2026" },
    ],
  },
  {
    id: "biography",
    num: "02",
    navLabel: "Biography",
    title: "Nick Fraser: biography and East London roots",
    blocks: [
      { type: "figure", image: "NICK_PORTRAIT" },
      { type: "p", text: "Nick Fraser was born in East London in 1946 and lived there for the whole of his life. In public he was, by every outward measure, a traditional East End man: devoted to his mother, shaped by work, faith and the rhythms of the city around him. He spent more than three decades employed at the Tate & Lyle factory, part of the industrial workforce that defined the post-war East End." },
      { type: "p", text: "In private, from the 1960s until his later life, he painted. Largely self-taught, working with construction materials and decorating supplies as readily as with conventional paint, he built a vast and almost entirely unseen body of work — large-scale paintings and multi-panel pieces that move between the cosmic and the bodily, the sacred and the comic, the tender and the confrontational." },
      { type: "p", text: "During his lifetime the work surfaced in public only rarely, in small pop-up showings including Lewisham Library and the Cutty Sark in Greenwich. He never sought representation, never courted the art world, and died in 2023 with his archive intact and largely unknown." },
      { type: "pull", text: "Behind the working life of Nick Fraser was a private artistic universe of remarkable intensity." },
    ],
  },
  {
    id: "practice",
    num: "03",
    navLabel: "A hidden practice",
    title: "A hidden artistic practice",
    blocks: [
      { type: "p", text: "Fraser's practice developed entirely outside the structures through which artists usually become visible: no art school, no gallery, no dealer, no market. What disciplined the work instead was need. He painted, by the account of those closest to him, because painting was how he processed existence — faith, the body, humour, hardship and the questions that did not have an easy public language." },
      { type: "figure", image: "HIDDEN_PRACTICE_ARTWORK_01" },
      { type: "p", text: "The materials tell the same story. Boards, panels and surfaces from everyday working life; decorating supplies bought when money allowed; compositions worked at domestic scale and, frequently, well beyond it. The result is a body of work that is raw and devotional at once — technically unorthodox, but sustained across five decades with a consistency of vision that is difficult to overstate." },
      { type: "p", text: "Because the practice was private, the archive is also unusually undisturbed. The works were not dispersed through sales, trimmed for exhibitions or reframed for fashion. What survives is close to the complete, unedited output of one imagination — with all the art-historical value that entails." },
      { type: "pull", text: "Nothing will stop me from painting.", attribution: "Attributed to Nick Fraser · Chapter 1 film, as reported in Strand Magazine" },
    ],
  },
  {
    id: "themes",
    num: "04",
    navLabel: "Themes",
    title: "Themes within the work",
    blocks: [
      { type: "p", text: "Recurring across the archive are religious motifs, abstract cosmologies and repeated symbolic figures — beings outlined in black, coloured in deep browns, oranges and yellows, flecked with jewel red and blue, their eyes and open mouths caught between ecstasy and alarm. Strand Magazine's reviewer described works 'at once maverick and articulate, clearly made by a man with multitudes in his soul.'" },
      { type: "figure", image: "THEMES_ARTWORK_01" },
      { type: "p", text: "Faith is the archive's spine: biblical scenes, gestures of prayer, gates and thresholds recur throughout. But the register is searching rather than settled — devotional imagery pressed up against bodily, comic and confrontational elements, spirituality without certainty." },
      { type: "figure", image: "THEMES_ARTWORK_02" },
      { type: "p", text: "Read together, the works form a sustained meditation on masculinity, identity, isolation and emotional survival — subjects that men of Fraser's generation were rarely given the language to speak about, and which he addressed instead in paint. It is this dimension of the work that contemporary audiences, at Chapter 1 and since, have responded to most strongly." },
      { type: "pull", text: "Spiritual, tribal, ethereal — a faintly ominous other-worldly experience… World class.", attribution: "Visitor testimonial · Chapter 1, The Crypt Gallery" },
      { type: "figure", image: "FULL_PAGE_ARTWORK_01", full: true },
    ],
  },
  {
    id: "heritage",
    num: "05",
    navLabel: "British heritage",
    title: "Why the collection is significant to British heritage",
    lede: "The estate does not claim that Nick Fraser is nationally significant or institutionally recognised. It presents, instead, the case for why this archive merits serious assessment as a record of British working-class life and creativity.",
    blocks: [
      { type: "p", text: "The Nick Fraser Archive is, first, a social document. It records — from the inside, across half a century — the life of a post-war East End factory worker: the world of Tate & Lyle, of industrial East London, of faith and family and graft. That world has been extensively documented from outside, by historians and photographers. It has very rarely documented itself in sustained visual art. Fraser's archive is precisely that: an interior account of a way of life that has largely disappeared, made by someone who lived it." },
      { type: "figure", image: "TATE_AND_LYLE_ARCHIVE_IMAGE" },
      { type: "p", text: "Second, it is a case study in hidden creativity. British art history is increasingly attentive to self-taught and outsider practices — to the question of who gets to be called an artist and which lives are admitted into the record. Fraser worked entirely outside formal cultural institutions, and his archive survived not through the market but through friendship and family care. It offers researchers a near-complete example of a creative life conducted in private: how such a practice begins, what sustains it, and what it produces when it is never shaped by an audience." },
      { type: "p", text: "Third, it speaks to questions of pressing contemporary relevance: the relationship between manual labour and private creative expression; faith held and questioned; masculinity, identity, isolation and mental wellbeing in a generation of men taught endurance rather than articulacy. These are conversations Britain is having now, and the archive contributes to them in an unusually direct and affecting form." },
      { type: "p", text: "Finally, the archive's value is compounded by its context. The paintings do not stand alone: they are held alongside documentary footage, photographs, oral histories and first-hand recollection gathered by Mark O'Shaughnessy over a lifetime of friendship. It is this combination — artwork plus testimony — that makes the collection a heritage resource rather than simply a group of pictures." },
      { type: "list", items: "HERITAGE_THEMES", intro: "As a body of evidence, the archive offers a record of:" },
      { type: "figure", image: "PRESERVATION_ARCHIVE_IMAGE" },
    ],
  },
  {
    id: "collection",
    num: "06",
    navLabel: "The archive",
    title: "What The Nick Fraser Archive contains",
    lede: "The archive is currently held privately by the estate and has not yet been formally catalogued. No figures for the number of works are published here; counts will be released once professional cataloguing is complete.",
    blocks: [
      { type: "figure", image: "COLLECTION_OVERVIEW_IMAGE" },
      { type: "cards", items: "COLLECTION" },
    ],
  },
  {
    id: "documentary",
    num: "07",
    navLabel: "The documentary record",
    title: "Mark O'Shaughnessy's documentary record",
    blocks: [
      { type: "p", text: "Mark O'Shaughnessy was Nick Fraser's lifelong friend, muse and advocate — and, in practice, the archive's first archivist. Across the decades of their friendship he accumulated what no institution could now reconstruct: footage of the artist, photographs, recollections of working methods and beliefs, and the day-to-day context of the life from which the paintings came." },
      { type: "figure", image: "DOCUMENTARY_STILL_01" },
      { type: "p", text: "Elements of this record formed the film screened within Chapter 1 at The Crypt Gallery, which Strand Magazine's reviewer singled out as central to the exhibition's impact. A further film accompanies Chapter II." },
      { type: "figure", image: "DOCUMENTARY_STILL_02" },
      { type: "p", text: "For researchers, this material is as significant as the paintings themselves. Outsider archives frequently survive as objects stripped of context; here, the context survives too — in first person. The estate regards the preservation and formal recording of Mark's testimony as one of the project's most urgent priorities, for the simple reason that it is held in living memory." },
      { type: "films" },
      { type: "figure", image: "MARK_AND_MARCUS_PORTRAIT" },
    ],
  },
  {
    id: "recognition",
    num: "08",
    navLabel: "Recognition & timeline",
    title: "Public recognition and project timeline",
    blocks: [
      { type: "p", text: "Public knowledge of Nick Fraser begins, in effect, in 2024. In the short period since, the response has been consistent: Strand Magazine's extended review of Chapter 1 called the work 'unforgettable' and named Fraser 'an artist to remember'; the international journal Raw Vision featured his life and work in Issue 121; local radio (Vibe 107.6 FM) covered the project's announcement; and visitor testimony has been repeatedly, strikingly moved." },
      { type: "figure", image: "RAW_VISION_FEATURE_IMAGE" },
      { type: "pull", text: "An artist to remember, and a curator to watch.", attribution: "Sophie-May Ward-Marchbank · Strand Magazine, reviewing Chapter 1" },
      { type: "timeline" },
    ],
  },
  {
    id: "chapter-1",
    num: "09",
    navLabel: "Chapter 1",
    title: "Chapter 1 — The Crypt Gallery, 2024",
    blocks: [
      { type: "p", text: "Chapter 1, curated by Marcus O'Shaughnessy, opened at The Crypt Gallery beneath St Pancras Parish Church in 2024 — the first substantial public presentation of the work, showing paintings publicly for the first time in decades alongside the documentary film. The crypt's alcoves and low vaulted spaces framed the paintings at close, devotional range." },
      { type: "figure", image: "CHAPTER_1_INSTALLATION_01" },
      { type: "p", text: "The critical and public response exceeded the estate's expectations. Strand Magazine published an extended review describing 'one of the most full-bodied, tender, and devoted installations I have attended in the past year'; visitors described the experience as 'spiritual, tribal, ethereal' and 'world class'. Chapter 1 established the project's method: careful, chapter-by-chapter revelation of the archive, each exhibition accompanied by film and context." },
      { type: "figure", image: "CHAPTER_1_INSTALLATION_02" },
    ],
  },
  {
    id: "chapter-2",
    num: "10",
    navLabel: "Chapter II",
    title: "Chapter II — Shoreditch Arts Club, 31 July 2026",
    blocks: [
      { type: "p", text: "Chapter II brings the work home to East London: a one-day exhibition at Shoreditch Arts Club on Friday 31 July 2026, comprising rarely seen paintings from the archive, an immersive projection installation, a cinema screening of the film, an evening private view with live performance, and the introduction of the first limited edition prints from the archive." },
      { type: "figure", image: "CHAPTER_2_INSTALLATION_01" },
      { type: "p", text: "The one-day format is deliberate. Each chapter is conceived as an event of concentrated attention rather than a run — consistent with the estate's approach of releasing the archive slowly and on its own terms. Full details are published at chapter2.nickfraserartist.com." },
      { type: "figure", image: "FULL_PAGE_ARTWORK_02", full: true },
    ],
  },
  {
    id: "preservation",
    num: "11",
    navLabel: "Preservation proposal",
    title: "The heritage-preservation proposal",
    lede: "What the estate is seeking to do, and where partnership is invited.",
    blocks: [
      { type: "p", text: "The archive is currently safe, but informally held. The estate's preservation programme — for which it is seeking institutional partnership, expertise and funding — comprises five strands:" },
      { type: "list", items: [
        "Cataloguing — a professional catalogue of the complete archive: titling, dating, measuring, photographing and condition-reporting every work, to archival documentation standards.",
        "Conservation — condition assessment and stabilisation of works made on unconventional and sometimes fragile materials, with priority treatment where deterioration is active.",
        "Digitisation — high-resolution photography of the works and professional digitisation of the documentary footage, photographs and papers, creating a research-grade digital archive.",
        "Oral history — the formal recording, transcription and archiving of Mark O'Shaughnessy's testimony and that of others who knew the artist, while this is possible.",
        "Appropriate storage & access — archival-standard storage for the physical collection, and a framework through which researchers and institutions can request access.",
      ] },
      { type: "p", text: "The estate is deliberately not proposing outcomes it cannot yet deliver. The immediate goal is not a permanent gallery but a properly documented, conserved and accessible archive — the foundation on which any longer-term institutional future depends." },
    ],
  },
  {
    id: "education",
    num: "12",
    navLabel: "Education & research",
    title: "Education, research and community value",
    blocks: [
      { type: "p", text: "The archive's educational potential follows directly from what it is. For schools and community settings — particularly in East London — Nick's story offers an unusually direct way into conversations about creativity, class, mental wellbeing and self-expression: a local man, a recognisable working life, and an extraordinary private world made with materials anyone could afford." },
      { type: "p", text: "For researchers, the archive offers primary material across several fields: British outsider and self-taught art; the social history of the post-war East End and its industries; faith and vernacular religious imagery; masculinity and emotional expression; and the methodology of preserving artist estates that arise outside institutions. The estate welcomes research enquiries now, ahead of formal cataloguing." },
      { type: "p", text: "The project's community dimension is already in evidence: Chapter 1 and Chapter II have been built through local audiences, friends and supporters rather than institutional backing, and the estate works alongside Imaginative Reaction CIC, the community interest company founded by Marcus O'Shaughnessy, whose stated purpose includes bringing Nick's work to light and supporting the wider community." },
    ],
  },
  {
    id: "future",
    num: "13",
    navLabel: "Future vision",
    title: "Future vision and institutional partnerships",
    blocks: [
      { type: "p", text: "The estate's long-term vision is that The Nick Fraser Archive should outlive its current custodians: catalogued, conserved, publicly accessible, and held — in whole or in part, physically or digitally — where it can be studied and seen. How that is best achieved is a question the estate wants to answer with partners rather than alone." },
      { type: "p", text: "The estate therefore invites conversation with museums, archives, galleries, universities, funding bodies and cultural organisations on any of the following: loans and exhibitions drawn from the archive; research collaboration and supervision; conservation and cataloguing expertise or funding; digitisation partnership; educational programming; and, in time, discussions about a long-term home for the collection." },
      { type: "p", text: "Nick Fraser reportedly dreamed of 'an installation — somewhere, wherever' (as described in Strand Magazine). The estate's ambition is more modest and more durable: that the work is never again at risk of disappearing." },
      { type: "pull", text: "An installation — somewhere, wherever.", attribution: "Attributed to Nick Fraser · adapted from Strand Magazine's account of his hopes for the work" },
    ],
  },
  {
    id: "contact",
    num: "14",
    navLabel: "Contact",
    title: "Contact details and acknowledgements",
    blocks: [
      { type: "contact" },
      { type: "p", text: "Acknowledgements: the estate thanks Shoreditch Arts Club; The Crypt Gallery, St Pancras Parish Church; Sophie-May Ward-Marchbank and Strand Magazine; Artemis Van Dorssen and Raw Vision; Vibe 107.6 FM; BoThai; and the friends, family, visitors and supporters of Chapter 1 and Chapter II, without whom the archive would remain unseen." },
      { type: "p", text: "Accuracy statement: this prospectus is compiled from the estate's records, published reviews and coverage, and the first-hand testimony of Mark and Marcus O'Shaughnessy. Statements attributed to Nick Fraser derive from the Chapter 1 film as reported in published coverage and should be verified against the film transcript before formal citation. No collection statistics are published pending professional cataloguing. Corrections are welcomed at info@nickfraserartist.com." },
    ],
  },
];
